// entryId 변경
export const SET_ENTRY_ID = "SET_ENTRY_ID";

// 날짜 계산의 기준이 되는 날짜
export const SET_STANDARD_DATE = "SET_STANDARD_DATE";

// 활성화된 날짜
export const SET_ACTIVE_DATE = "SET_ACTIVE_DATE";

// 활성화된 날짜 타입
export const SET_ACTIVE_DATE_TYPE = "SET_ACTIVE_DATE_TYPE";

// 최소 날짜 값
export const SET_MIN_DATE = "SET_MIN_DATE";

// hover된 index
export const SET_HOVER_DATE_INDEX = "SET_HOVER_DATE_INDEX";

// active된 index
export const SET_ACTIVE_DATE_INDEX = "SET_ACTIVE_DATE_INDEX";

// 전체 PV
export const SET_TOTAL_COUNT = "SET_TOTAL_COUNT";

// 모든 store값 초기화
export const INIT_ALL_OF_STORE = "INIT_ALL_OF_STORE";


